import React from 'react';
import Money from "../../../components/Common/Money";
import CartHelper from "../../../services/Cart/Helper/CartHelper";
import {parseDate} from "../../../services/Common/Date/DateHelper";
import CartItemsNewComponent from "../../../components/Cart/components/CartItemsNewComponent";


interface Props {
    orderItems: any,
    items: any,
    modifierGroups: any
}

const SummaryItemsComponent = (props: Props) => {
    const visibileModifierGroupName = false;
    const renderItemPrice = function (item: any) {
        if (item.discount_money !== undefined && item.discount_money.amount !== 0) {
            let subTotalPrice = item.total_money.amount + item.discount_money.amount;
            return (
                <React.Fragment>
                    <span className="text-danger">
                        <del>
                        <Money
                            value={subTotalPrice}
                            currency='PLN'/>
                        </del>
                    </span>
                    <Money
                        value={item.total_money.amount}
                        currency='PLN'/>
                </React.Fragment>
            )
        }
        return (
            <Money
                value={item.total_money.amount}
                currency='PLN'/>
        )
    }
    let orderItems = props.orderItems;

    const renderSubItems = (itemModifierGroups: any, modifierGroups: any, items: any, lvl?: any) => {
        if (!itemModifierGroups || itemModifierGroups.length <= 0) return null;
        if (!lvl) lvl = 0;
        if (visibileModifierGroupName) {
            return (
                <>
                    {
                        itemModifierGroups.sort((a: any, b: any) => a.name.localeCompare(b.name)).map((itemModifierGroup: any) =>
                            <ul className="list-inline" key={itemModifierGroup.id}>
                                <h5>
                                    {CartHelper.getItemName(modifierGroups, itemModifierGroup.modifier_group_id, itemModifierGroup.name)}
                                </h5>
                                {
                                    itemModifierGroup.selected_items.sort((a: any, b: any) => a.name.localeCompare(b.name)).map((selectedItem: any) =>
                                        <li className={`${isModifiers(selectedItem) ? "list-inline-item list-inline-item-multi" : "list-inline-item"}`}
                                            key={selectedItem.id}>
                                            {selectedItem.quantity}x {CartHelper.getItemName(items, selectedItem.item_id, selectedItem.name)}
                                            {renderSubItems(selectedItem.modifier_groups, modifierGroups, items, lvl + 1)}
                                        </li>
                                    )
                                }
                            </ul>
                        )
                    }
                </>
            )
        }
        return (
            <ul className="list-inline">
                {
                    itemModifierGroups.sort((a: any, b: any) => a.name.localeCompare(b.name)).flatMap((x: any) => x.selected_items).sort((a: any, b: any) => a.name.localeCompare(b.name)).map((selectedItem: any) =>
                        <li className={`${isModifiers(selectedItem) ? "list-inline-item list-inline-item-multi" : "list-inline-item"}`}
                            key={selectedItem.id}>
                            {isModifiers(selectedItem) ? (
                                <h5>
                                    {selectedItem.quantity}x {CartHelper.getItemName(items, selectedItem.item_id, selectedItem.name)}
                                </h5>
                            ) : (
                                <>
                                    {selectedItem.quantity}x {CartHelper.getItemName(items, selectedItem.item_id, selectedItem.name)}
                                </>
                            )}
                            {renderSubItems(selectedItem.modifier_groups, modifierGroups, items, lvl + 1)}
                        </li>
                    )
                }
            </ul>
        )
    }
    const isModifiers = (item: any) => {
        return item.modifier_groups && item.modifier_groups.length > 0;
    }
    return (
        <div>
            <div className={"cart-items-body"}>

                {
                    orderItems.sort((a: any, b: any) => parseDate(a.created_at).getTime() - parseDate(b.created_at).getTime()).map((item: any) =>
                        <>
                            <div key={item.id} className={"cart-item"}>
                                {(item && item.image_link?.small) && (
                                    <div className={"cart-item-img"}>
                                        <img src={item.image_link.small} alt={item.name}/>
                                    </div>
                                )}
                                <div className={"cart-item-body"}>
                                    <h3>
                                        {CartHelper.getItemName(props.items, item.item_id, item.name)} {item.quantity && item.quantity}
                                    </h3>
                                    <div className={"cart-item-description"}>
                                        {renderSubItems(item.modifier_groups, props.modifierGroups, props.items)}
                                        {item.comment && (
                                            <i>{item.comment}</i>
                                        )}
                                    </div>
                                    <div className={"cart-item-bottom"}>
                                        <div className={"cart-item-prices"}>
                                            {renderItemPrice(item)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
}
export default SummaryItemsComponent;